import React, { useEffect, useState } from 'react';
import { store } from 'redux/store';
import { setCurrentTab, setSearchQuery } from 'redux/reducers/mailerLayoutReducer';
import MassEmailListing from 'components/Admin/Mailer/MassEmail/Listing';
import MassEmailListingMobile from 'components/Admin/Mailer/MassEmail/Mobile';
import MassEmailNew from 'components/Admin/Mailer/MassEmail/New';
import { useClosure } from 'utils/hooks';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function MailerMassEmail() {
  useEffect(() => {
    store.dispatch(setCurrentTab('mass-emails'));
    store.dispatch(setSearchQuery(''));
  }, []);
  const [isNewMassEmail, setIsNewMassEmail] = useState(false);
  const onNewClick = useClosure(setIsNewMassEmail, true);
  const onCloseClick = useClosure(setIsNewMassEmail, false);
  const isMobile = useIsMobile();

  if (isNewMassEmail) {
    return <MassEmailNew close={onCloseClick} />;
  }

  return isMobile
    ? <MassEmailListingMobile onNewClick={onNewClick} />
    : <MassEmailListing onNewClick={onNewClick} />;
}
